<template>
    <el-dialog
        :title="isAdd ? '添加字段' : '修改字段'"
        width="34%"
        :visible.sync="isShowDialog"
        @close="$emit('hide')">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="add-scheme-form">
            <el-form-item label="身份">
                <el-radio-group :disabled="!isAdd" v-model="form.userType">
                    <el-radio label="student">学生</el-radio>
                    <el-radio label="teacher">老师</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item required label="字段名称" prop="formName">
                <el-input v-model="form.formName"></el-input>
            </el-form-item>
            <el-form-item label="字段类型">
                <el-select :disabled="!isAdd" v-model="form.formKey" placeholder="请选择字段类型">
                    <el-option
                        v-for="(item ,index) in formTypeList"
                        :key="index"
                        :label="item.fieldName"
                        :value="item.fieldKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="form.formKey === 'picture'"
                label="图片张数"
                prop="photoNum"
                required>
                <el-input type="number" v-model="form.photoNum"></el-input>
            </el-form-item>
            <el-form-item
                label="排序"
                prop="rank"
                required>
                <el-input type="number" v-model="form.rank"></el-input>
            </el-form-item>
            <el-form-item label="必填">
                <el-switch
                    v-model="form.required">
                </el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="isSubmitLoading" @click.stop="onSaveData">保存</el-button>
                <el-button @click.stop="$emit('hide')">取消</el-button>
            </span>
    </el-dialog>
</template>
<script>
import api from '@/api/index.js'
export default {
    name: 'AddScheme',
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        schemeInfo: {
            type: Object,
            default: () => ({
                isAdd: true,
                item: {}
            })
        },
        formTypeList: {
            type: Array,
            default: () => ([])
        }
    },
    data () {
        return {
            form: {
                userType: 'student',
                formName: '',
                formKey: 'input',
                photoNum: undefined,
                rank: undefined,
                required: true // 默认必填
            },
            rules: {
                formName: [ { required: true, message: '必填项', trigger: 'blur' } ],
                photoNum: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ]
            },
            isShowDialog: false,
            isSubmitLoading: false
        }
    },
    computed: {
        isAdd () {
            return this.schemeInfo.isAdd
        }
    },
    watch: {
        isShow (val) {
            this.isShowDialog = val
            if (this.schemeInfo.isAdd) {
                this.form = {
                    userType: 'student',
                    formName: '',
                    formKey: 'input',
                    photoNum: undefined,
                    rank: undefined,
                    required: false
                }
            } else {
                const { fieldType, fieldName, fieldKey, photoNum, rank, isNull } = this.schemeInfo.item
                this.form = {
                    userType: fieldType === '学生' ? 'student' : 'teacher',
                    formName: fieldName,
                    formKey: fieldKey,
                    photoNum: photoNum,
                    rank: rank,
                    required: !isNull
                }
            }
        }
    },
    created () {
        // input 1
        // textarea 2
        // picture 3
        // deleteFormTypeList
        // api.addFormTypeList({
        //     fieldKey: 'textarea',
        //     fieldName: '多行文本',
        //     fieldType: '2'
        // })
        // api.deleteFormTypeList({
        //     fieldType: 1
        // })
    },
    methods: {
        onSaveData () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.schemeInfo.isAdd) {
                        this.addScheme()
                    } else {
                        this.editScheme()
                    }
                }
            })
        },
        async addScheme () {
            try {
                this.isSubmitLoading = true
                const { formName, formKey, required, photoNum, userType, rank } = this.form
                const folderId = this.formTypeList.find(m => m.fieldKey === formKey).fieldType
                const data = {
                    fieldKey: formKey,
                    fieldType: folderId,
                    defaultField: 1,
                    fieldName: formName,
                    isNull: required ? 0 : 1,
                    photoNum: photoNum,
                    rank: rank,
                    userType: userType === 'teacher' ? 1 : 2
                }
                const resp = await api.addScheme(data)
                if (resp.success) {
                    this.$message.success('添加字段成功');
                    this.$emit('hide', true)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.isSubmitLoading = false
            }
        },
        async editScheme () {
            // editScheme
            try {
                this.isSubmitLoading = true
                const { formName, formKey, required, photoNum, userType, rank } = this.form
                const data = {
                    field_id: this.schemeInfo.item.fieldId,
                    field_name: formName,
                    photoNum: photoNum,
                    rank: rank,
                    is_null: required ? 0 : 1
                }
                const resp = await api.editScheme(data)
                if (resp.success) {
                    this.$message.success('添加字段成功');
                    this.$emit('hide', true)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.isSubmitLoading = false
            }
        }
    }
}
</script>
<style lang="scss" scopes>
.add-scheme-form {
    width: 80%;
}
</style>